import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoinflipDeprecatedService } from '../coinflip.service';
import { CoinflipStatsListComponent } from '../coinflip-stats-list/coinflip-stats-list.component';
import { CoinflipCoinComponent } from '../../../features/coinflip/coinflip-coin/coinflip-coin.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-coinflip-stats',
  templateUrl: './coinflip-stats.component.html',
  styleUrls: ['./coinflip-stats.component.scss'],
  imports: [CoinflipStatsListComponent, CoinflipCoinComponent, RouterLink],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoinflipStatsComponent {
  constructor(public deprecatedCoinflipService: CoinflipDeprecatedService) {}
}
